import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Swal from "sweetalert2";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    filtradoNombres: [],
    usuarioGlobal: [],
    posts: [],
    idDni: [],
    permisos: [],
    contratos: [],
    tecnologia: [],
    operaciones: [],
    sst: [],
    bienestar: [],
    nominas: [],
    tesoreria: [],
    contabilidad: [],
    postulante: [],
    nombreUsers: "",
    cargo: "",
    correo: "",
    modal: false,
    moduloRapido: [],
    iconoModulo: [],
    idReporte: "",
    idGrupo: "",
    activarTokenbi: false

  },
  getters: {
    Modal(state) {
      return state.modal;
    },
    Items(state) {
      return state.filtradoNombres;
    },

    Users(state) {
      return state.usuarioGlobal;
    },

    DniEmpre(state) {
      return state.idDni;
    },

    Posts(state) {
      return state.posts;
    },

    NombresUsers(state) {
      return state.nombreUsers;
    },

    Cargos(state) {
      return state.cargo;
    },

    Permisos(state) {
      return state.permisos;
    },

    Contratos(state) {
      return state.contratos;
    },

    Tecnologia(state) {
      return state.tecnologia;
    },

    Operaciones(state) {
      return state.operaciones;
    },

    Bienestar(state) {
      return state.bienestar;
    },

    Sst(state) {
      return state.sst;
    },

    Nominas(state) {
      return state.nominas;
    },

    Tesoreria(state) {
      return state.tesoreria;
    },

    Contabilidad(state) {
      return state.contabilidad;
    },

    Postulante(state) {
      return state.postulante;
    },

    Correo(state) {
      return state.correo;
    },

    ModuloRapido(state) {
      return state.moduloRapido
    },

    IconoModulo(state) {
      return state.iconoModulo
    },

    Idreporte(state) {
      return state.idReporte
    },
    Idgrupo(state) {
      return state.idGrupo
    },
    ActivarTokenbi(state) {
      return state.activarTokenbi;
    },


  },

  mutations: {
    llenarModal(state, data) {
      state.modal = data;
    },

    llenarItems(state, data) {
      state.filtradoNombres = data;
    },
    llenarUsuario(state, data) {
      state.usuarioGlobal = data;
    },
    llenarDni(state, data) {
      state.idDni = data;
    },
    llenarPosts(state, data) {
      state.posts = data;
    },
    llenarUsers(state, data) {
      state.nombreUsers = data;
    },
    llenarCargos(state, data) {
      state.cargo = data;
    },

    llenarCorreos(state, data) {
      state.correo = data;
    },

    llenarPermisos(state, data) {
      state.permisos = data;
    },
    llenarContratos(state, data) {
      state.contratos = data;
    },
    llenarTecnologia(state, data) {
      state.tecnologia = data;
    },
    llenarOperaciones(state, data) {
      state.operaciones = data;
    },
    llenarBienestar(state, data) {
      state.bienestar = data;
    },
    llenarSst(state, data) {
      state.sst = data;
    },
    llenarNominas(state, data) {
      state.nominas = data;
    },
    llenarTesoreria(state, data) {
      state.tesoreria = data;
    },

    llenarContabilidad(state, data) {
      state.contabilidad = data;
    },

    llenarPostulante(state, data) {
      state.postulante = data;
    },

    llenarModulosRapido(state, data) {
      state.moduloRapido = data
    },

    llenarIconoModulo(state, data) {
      state.iconoModulo = data
    },

    llenarIdreporte(state, data) {
      state.idReporte = data
    },

    llenarIdgrupo(state, data) {
      state.idGrupo = data
    },
    activarTokenbi(state, valor) {
      state.activarTokenbi = valor;
    },


  },
  actions: {
    async getAttributes({ commit }) {
      const token = localStorage.getItem("access_token");
      const usuarioIngresado = localStorage.getItem("userId");

      try {
        axios
          .get(`BIClientes/PermisosUsuario/${usuarioIngresado}`, {
            headers: { authorization: "Bearer " + token },
          })
          .then((datos) => {
            console.log(datos);
            // let nombreCompleto = `  ${datos.data[0].usuApePaterno} ${datos.data[0].usuApeMaterno} ${datos.data[0].usuNombres}`;
            let nombreCompleto = `${datos.data[0].usuNombres} ${datos.data[0].usuApePaterno}`;
            commit("llenarUsers", nombreCompleto);
            commit("llenarCargos", datos.data[0].cargo);
            commit("llenarCorreos", datos.data[0].correoUsu);
            commit('llenarModulosRapido', datos.data)

            console.log('data', datos.data);

            localStorage.setItem("dniUsers", datos.data[0].usuDocumento);

            // axios
            //   .get(`Empresa/EmpresaxTrabajador/${datos.data[0].usuDocumento}`)
            //   .then((r) => {
            //     commit("llenarDni", r.data);
            //     console.log(r.data);
            //   });


            let des = [];
            let iconoModulo = []

            for (let itema of datos.data) {
              if (itema.catplataform == 2) {

                des.push(itema.modNombre);

                let result = des.filter((item, index) => {
                  return des.indexOf(item) === index;
                });


                iconoModulo.push(itema.desIconoModulo)
                let iconos = iconoModulo


                commit("llenarUsuario", datos.data);
                commit('llenarIconoModulo', iconos)

                commit("llenarItems", result);

                console.log(des)
                console.log(iconos)
              }

              // commit('llenarTrabajador', datos.data[0].idTrabajador)
            }
          })
          .catch((error) => {
            console.log(error.message)

            if (error.message == "Network Error") {
              commit("llenarModal", true);
              Swal.fire({
                title: "Tu sesión ha expirado",
                //  text: "You won't be able to revert this!",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "VOLVER A LOGUEARSE",
              }).then((result) => {
                if (result.isConfirmed) {
                  Swal.fire(
                    window.location.reload(true),
                    localStorage.clear(),
                    this.$router.push("/")
                  );
                }
              });
            }

            if (error.response.status == 401) {
              commit("llenarModal", true);
              Swal.fire({
                title: "Tu sesión ha expirado",
                //  text: "You won't be able to revert this!",
                icon: "warning",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "VOLVER A LOGUEARSE",
              }).then((result) => {
                if (result.isConfirmed) {
                  Swal.fire(
                    window.location.reload(true),
                    localStorage.clear(),
                    this.$router.push("/")
                  );
                }
              });
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  modules: {},
};
